// extracted by mini-css-extract-plugin
module.exports = {"inventorySearchForm":"InventorySearchForm_inventorySearchForm__28kBL","searchInput":"InventorySearchForm_searchInput__2dh8I"};